import React from 'react';
import Main from "./components/Main";
import Second from "./components/Second";
import Founder from "./components/Founder";
import CardList from "./components/cards/CardList";
import { Navigate, Route, Routes } from 'react-router-dom';
import CountryCardList from "./components/cards/CountryCardList";
import Link from "./components/Link";
import Adv from "./components/Adv";
import Reviews from "./components/Reviews";
import FAQ from "./components/FAQ";
import Gallery from "./components/Gallery";
import Lead from "./components/Lead";
import CardDetails from "./components/cards/CardDetails";
import AutoPark from "./components/AutoPark";
import Terms from "./components/Terms";
import ContactPage from "./components/ContactPage";
import Blog from "./components/Blog";
import BlogDetail from "./components/BlogDetail";


const App = () => {
    return (
        <Routes>
            <Route path="/" element={
                <div>
                    <Main/>
                    <div className="it-divider" />
                    <Second/>
                    <div className="it-divider" />
                    <Link/>
                    <div className="it-divider" />
                    <CardList/>
                    <div className="it-divider" />
                    <Adv/>
                    <div className="it-divider" />
                    <Reviews/>
                    <div className="it-divider" />
                    <Gallery/>
                    <div className="it-divider" />
                    <FAQ/>
                    <div className="it-divider" />
                    <Lead/>
                </div>
            }/>
            <Route path="/autopark" element={<AutoPark />} />
            <Route path="/chi-siamo" element={<Founder />} />
            <Route path="/country/:id" element={<CountryCardList />} />
            <Route path="/country/tour/:id" element={<CardDetails />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contacts" element={<ContactPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/team" element={<Navigate to="/chi-siamo#team" replace />} />
        </Routes>
    );
};

export default App;
